import { render, staticRenderFns } from "./ext-product-price-layout.vue?vue&type=template&id=48736a54&scoped=true"
import script from "./ext-product-price-layout.vue?vue&type=script&lang=js"
export * from "./ext-product-price-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48736a54",
  null
  
)

export default component.exports